import { render, staticRenderFns } from "./DurationSummary.vue?vue&type=template&id=59d1a7ff&scoped=true"
import script from "./DurationSummary.vue?vue&type=script&lang=js"
export * from "./DurationSummary.vue?vue&type=script&lang=js"
import style0 from "./DurationSummary.vue?vue&type=style&index=0&id=59d1a7ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d1a7ff",
  null
  
)

export default component.exports